import { calcSalary } from './calcSalary';

export const calcSalaryForOne = (data, payment) => {
	return (
		calcSalary(data.big_items_count, data.small_items_count, payment) /
			data.delivered_count || 0
	);
};
